import { useEffect, useState } from "react";

/**
 * Like useState but persisted to localStorage by key.
 * Serializes via JSON; supports Sets via a {__set: [...]} envelope.
 */
export default function useLocalStorageState(key, initial) {
  const [val, setVal] = useState(() => {
    try {
      const raw = localStorage.getItem(key);
      if (raw == null) return initial;
      const parsed = JSON.parse(raw);
      if (parsed && parsed.__set && Array.isArray(parsed.__set)) {
        return new Set(parsed.__set);
      }
      return parsed;
    } catch (e) { console.warn(`useLocalStorageState[${key}] parse failed:`, e); return initial; }
  });
  useEffect(() => {
    try {
      const toStore = val instanceof Set ? { __set: Array.from(val) } : val;
      localStorage.setItem(key, JSON.stringify(toStore));
    } catch (e) { console.warn(`useLocalStorageState[${key}] write failed (quota/private mode):`, e); }
  }, [key, val]);
  return [val, setVal];
}
